import { StatusBar } from 'expo-status-bar';
import React from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import useCachedResources from './hooks/useCachedResources';
import useColorScheme from './hooks/useColorScheme';
import Navigation from './navigation';
import { Platform, UIManager } from 'react-native';
import { FontInfo } from './.vscode/src/~Utilities/Constants';
import { Connection } from './.vscode/src/~Utilities/Connection';
import { GestureHandlerRootView } from 'react-native-gesture-handler';


// if (Platform.OS === 'android') {
//   if (UIManager.setLayoutAnimationEnabledExperimental) {
//     UIManager.setLayoutAnimationEnabledExperimental(true);
//   }
// }

/*   ---------------------------------------------------------------------   */ 

// FIXME need reanimated update, see https://github.com/software-mansion/react-native-reanimated/issues/3355
if (Connection.IsWeb() == true) {
  // @ts-ignore
  window._frameTimestamp = null
}

export default function App() {

  const isLoadingComplete = useCachedResources();
  const colorScheme       = useColorScheme();
  const [isfontsLoaded]   = FontInfo.LoadFonts();

  if (!isLoadingComplete || !isfontsLoaded) {
    return null;
  } else {
    return (
      <GestureHandlerRootView style={{ flex: 1 }}>
      <SafeAreaProvider >
        <Navigation colorScheme={colorScheme} />
        <StatusBar />
      </SafeAreaProvider>
      </GestureHandlerRootView>
    );
  }
}